/* app/ui/listing/pagination */

define(
	'app/ui/listing/pagination',[
		'jquery',
		'pubsub'
	],
	function($) {

		var Module;


		var $listingContainer;
		var currentPage;
		var perPage = 10;
		var pagingData = {};
		var baseUrl = '?';

		return {
			init: function($elm) {
				Module = this;
				$listingContainer = $elm;

				var pageMatch = document.location.search.match(/(\?|&)page=(\d*?)(&|$)/);
				if (pageMatch) {
					currentPage = parseInt(pageMatch[2], 10);
				} else {
					currentPage = 1;
				}

				Module._initEvents();
			},

			// Called by operator.js when new content is loaded
			// Builds and returns a pagingData object
			getPagingData: function (feedData) {
				if (feedData.queryObj.queryString !== '') {
					baseUrl = feedData.queryObj.queryString + '&';
				}

				var pagesArray = Module._getPagesArray(feedData.Count, baseUrl);

				pagingData.total = feedData.Count || feedData.Listings.length;
				pagingData.pages = pagesArray;
				pagingData.pageCount = pagesArray.length.toString();
				pagingData.pageEnd = currentPage * (feedData.pageSize || perPage);
				pagingData.currentPage = currentPage;
				pagingData.hasPrevPage = currentPage > 1;
				pagingData.hasNextPage = currentPage < pagesArray.length;
				pagingData.pageStart = ((currentPage - 1) * perPage) + 1;
				pagingData.prevPageUrl = baseUrl + 'page=' + (currentPage - 1);
				pagingData.nextPageUrl = baseUrl + 'page=' + (currentPage + 1);

				if (currentPage === pagesArray.length) {
					pagingData.pageEnd = pagingData.total;
				}

				return pagingData;
			},

			// Listen for pagination events - number or next/prev clicks
			_initEvents: function() {
				$listingContainer.on('click', '.js-pagination-number', Module._numberClick);
				$listingContainer.on('click', '.js-pagination-dir', Module._directionClick);
				$listingContainer.on('change', '.js-pagination-dropdown', Module._mobileChange);
			},

			// Number click handler
			// Updates currentPage value
			// Update pagination object, reset = false (same data, new page)
			// Compile the pagination template
			_numberClick: function (event) {
				event.preventDefault();
				var $numLink = $(this);
				currentPage = parseInt($numLink.text());

				Module._updatePagingData();
			},

			// Direction link click handler
			// Updates currentPage value
			// Update pagination object, reset = false (same data, new page)
			// Compile the pagination template
			_directionClick: function (event) {
				event.preventDefault();
				var $dirLink = $(this);
				var direction = $dirLink.data('direction');

				if (direction === 'prev') {
					currentPage -= 1;
				}
				if (direction === 'next') {
					currentPage += 1;
				}

				Module._updatePagingData();
			},

			_mobileChange: function() {
				var value = parseInt($(this).val());
				
				if (value) {
					currentPage = value;
					Module._updatePagingData();
				}
			},

			// Update pagingData properties
			_updatePagingData: function () {

				pagingData.currentPage = currentPage;
				pagingData.pageStart = ((currentPage - 1) * perPage) + 1;
				pagingData.pageEnd = currentPage * perPage;
				pagingData.hasPrevPage = currentPage > 1;
				pagingData.pages = Module._getPagesArray(pagingData.total);
				pagingData.pageCount = pagingData.pages.length.toString();
				pagingData.hasNextPage = currentPage < pagingData.pages.length;
				pagingData.prevPageUrl = baseUrl + 'page=' + (currentPage - 1);
				pagingData.nextPageUrl = baseUrl + 'page=' + (currentPage + 1);

				if (currentPage === pagingData.pages.length) {
					pagingData.pageEnd = pagingData.total;
				}

				$.publish('/pagination/update', pagingData);
			},

			// Return array of page objects
			_getPagesArray: function (total) {
				var pageCount = Math.ceil(total / perPage);
				var pageArray = [];

				for (var i = 0; i < pageCount; i++) {
					var number = i + 1;
					var selectedClass = currentPage === number ? 'is-selected' : '';
					var selectedAttr = currentPage === number ? ' selected="selected"' : '';

					var page = {
						pageNumber: number,
						pageUrl: baseUrl + 'page=' + number,
						selectedClass: selectedClass,
						selectedAttr: selectedAttr
					};
					pageArray.push(page);
				}

				return pageArray;
			}
		};
	}
);
